import type { CategoryMapPoint } from './types';

// Concrete hex required by recharts SVG fills; mapped to the Tailwind palette:
// zinc-300 (normal), amber-500 (borderline), red-500 (misplaced).
const COLOR_NORMAL = '#d4d4d8';
const COLOR_BORDERLINE = '#f59e0b';
const COLOR_MISPLACED = '#ef4444';

export function statusColor(status: CategoryMapPoint['status']): string {
  if (status === 'misplaced') {
    return COLOR_MISPLACED;
  }
  if (status === 'borderline') {
    return COLOR_BORDERLINE;
  }
  return COLOR_NORMAL;
}
